import {
  analyticsProductsKeys,
  experienceProductsKeys,
  offerProductsKeys,
} from "@src/api/queryKeys";
import { queryClient } from "@src/queryClient";
import type { AppListenerMiddleware } from "@src/store/rootState";
import {
  recordCompletedSave,
  selectedExperience,
} from "@src/store/slices/experiences/index";
import { sendWebsocketMessage } from "@src/store/slices/global";

export function setupExperiencesListener(middleware: AppListenerMiddleware) {
  middleware.startListening({
    actionCreator: sendWebsocketMessage,
    effect: async (action, { getState, dispatch }) => {
      if (
        action.payload.type === "processUpdate" &&
        action.payload.action === "end" &&
        action.payload.process.type === "putExperience" &&
        !(
          "severity" in action.payload.process &&
          action.payload.process.severity === "error"
        )
      ) {
        dispatch(
          recordCompletedSave({
            experienceId: action.payload.process.id,
            at: Date.now(),
          })
        );
        const experience = selectedExperience(getState());
        if (experience?.id) {
          await Promise.all([
            queryClient.invalidateQueries({
              queryKey: experienceProductsKeys.one(action.payload.process.id),
            }),
            queryClient.invalidateQueries({
              queryKey: offerProductsKeys.one(action.payload.process.id),
            }),
            queryClient.invalidateQueries({
              queryKey: analyticsProductsKeys.one(action.payload.process.id),
            }),
          ]);
        }
      }
    },
  });
}
